<template>

<com-item name="game.heatmap" :size="size" :is-empty="!active" :loading="loading" title="Heatmap" class="heatmap type-plays">

	<template v-slot:about>

		<p>An overview of {{ your }} plays of this game.</p>

	</template>

	<template v-slot:stats>

		<div class="heatmap-graph" v-show="active">

			<div class="heatmap-wrapper">

				<div class="heatmap-weeks" v-show="active">

					<div class="heatmap-week is-labels">
						<div v-for="year in years" v-bind:key="year" class="heatmap-day"><span>{{ year }}</span></div>
					</div>

					<div class="heatmap-week" v-for="(week, index) in weeks" v-bind:key="index">

						<div class="heatmap-day" v-tooltip="tooltip(day)" v-for="(day, dindex) in days(week)" v-bind:class="{'is-inactive': day.inactive, 'has-plays': day.plays, [playDensity(day)]: !day.inactive}" v-bind:key="dindex" v-on:click="onDayClick(day)">

						</div>

					</div>

				</div>

			</div>

		</div>

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'you', 'your', 'size'],

	components: {
		'com-item': comItem
	},

	data: function() {

		return {
			startSunday: true,
			weeks: []
		}

	},

	computed: {

		years: function() {

			var years = []

			var min = parseInt(this.$moment.unix(this.start).utc().format('YYYY'))
			var max = parseInt(this.$moment.utc().format('YYYY'))

			for (var i = max; i >= min; i--) {

				years.push(i)

			}

			return years

		},

		start: function() {

			return this.storeData.start

		},

		end: function() {

			return this.storeData.end

		},

		loading: function() {

			return this.fetching === 'all'

		},

		storeData: function() {

			return this.$store.getters['page/insights/game/heatmap']

		},

		active: function() {

			return this.storeData.total && !this.loading

		}

	},

	created: function() {

		var i

		for (i = 1; i <= 53; i++) {

			var days = []

			for (var j = 1; j <= 50; j++) {

				days.push({
					plays: 0,
					date: '',
					inactive: true
				})

			}

			this.weeks.push({
				days: days
			})

		}

		this.visualise()

	},

	watch: {

		storeData: function() {

			this.visualise()

		}

	},

	methods: {

		tooltip: function(day) {

			if (!day.inactive && day.plays) {

				var html = []

				html.push(day.plays.toString() + this.$util.plural('play', day.plays))

				html.push('<small>' + day.date + '</small>')

				return html.join('')

			} else {

				return false

			}

		},

		days: function(week) {

			var min = parseInt(this.$moment.unix(this.start).utc().format('YYYY'))
			var max = parseInt(this.$moment.utc().format('YYYY'))

			return week.days.slice(0, max - min + 1)

		},

		playDensity: function(day) {

			var density = Math.ceil(day.plays / 3.5)

			if (density > 5) density = 5

			return 'density-' + density

		},

		onDayClick: function(day) {

			if (day.plays && day.index && day.index.length) {

				var query = {
					'play.subset': day.index.join(',')
				}

				this.$routerPush({
					name: 'Plays',
					query: query
				}).catch(function(e) { console.log(e) })

			}

		},

		visualise: function() {

			this.startSunday = this.$store.getters['filter/config/insights/heatmap/start'] === 'sunday'

			var i, j, currentDate, entry, stamp, endDate

			var min = parseInt(this.$moment.unix(this.start).utc().format('YYYY'))
			var max = parseInt(this.$moment.unix(this.end).utc().format('YYYY'))

			for (i = 1; i <= 53; i++) {

				for (j = max; j >= min && j > max - 50; j--) {

					currentDate = this.$moment.utc().year(j).startOf('year')

					currentDate = currentDate.day((this.startSunday) ? 0 : 1)

					currentDate = currentDate.add('days', (i - 1) * 7)

					stamp = j + '/' + i

					entry = this.storeData.plays[stamp] || {}

					if (i === 53 || currentDate.isAfter(this.$moment.utc())) {

						this.weeks[i - 1].days[max - j].unix = false
						this.weeks[i - 1].days[max - j].date = false
						this.weeks[i - 1].days[max - j].plays = false
						this.weeks[i - 1].days[max - j].index = []
						this.weeks[i - 1].days[max - j].inactive = true

					} else if (parseInt(currentDate.format('M')) === 12 && parseInt(currentDate.format('D')) >= 23) {

						endDate = this.$moment(currentDate).utc().endOf('month')

						this.weeks[i - 1].days[max - j].unix = [currentDate.unix(), endDate.unix()]
						this.weeks[i - 1].days[max - j].date = currentDate.format(this.$util.date.format('Do', 'MMMM', ', YYYY')) + ' - ' + endDate.format(this.$util.date.format('Do', 'MMMM', ', YYYY'))
						this.weeks[i - 1].days[max - j].plays = entry.count || 0
						this.weeks[i - 1].days[max - j].index = entry.index || []
						this.weeks[i - 1].days[max - j].inactive = false

					} else {

						endDate = this.$moment(currentDate).utc().add(6, 'days')

						this.weeks[i - 1].days[max - j].unix = [currentDate.unix(), endDate.unix()]
						this.weeks[i - 1].days[max - j].date = currentDate.format(this.$util.date.format('Do', 'MMMM', ', YYYY')) + ' - ' + endDate.format(this.$util.date.format('Do', 'MMMM', ', YYYY'))
						this.weeks[i - 1].days[max - j].plays = entry.count || 0
						this.weeks[i - 1].days[max - j].index = entry.index || []
						this.weeks[i - 1].days[max - j].inactive = false

					}

				}

				for (j = min - 1; j > max - 50; j--) {

					this.weeks[i - 1].days[max - j].unix = false
					this.weeks[i - 1].days[max - j].date = false
					this.weeks[i - 1].days[max - j].plays = false
					this.weeks[i - 1].days[max - j].index = []
					this.weeks[i - 1].days[max - j].inactive = true

				}

			}

		}

	}

}

</script>

<style scoped>

.heatmap >>> .insights-item-content {
	min-height: auto;
	overflow-y: auto;
}

.heatmap-graph {
	width: 100%;
	padding: 15px;
	min-width: 900px;
}

.heatmap-wrapper {
	width: 100%;
}

.heatmap-weeks {
	width: 100%;
	display: grid;
	grid-template-columns: repeat(55, minmax(0, 1fr));
}

.heatmap-week {
	display: flex;
	flex-direction: column;
}

.heatmap-week.is-labels {
	grid-column: span 2;
}

.heatmap-day {
	border-radius: 4px;
	border: 1px solid #fff;
	transition: background-color 400ms ease-out;
	width: 100%;
	padding-top: calc(100% - 2px);
}

.heatmap-week.is-labels .heatmap-day {
	padding-top: calc(50% - 2px);
}

.heatmap-day.has-plays {
	cursor: pointer;
}

.heatmap-week.is-labels .heatmap-day span {
	position: absolute;
	color: #333;
	left: 0px;
	width: 100%;
	top: 50%;
	text-align: left;
	font-size: 10px;
	transform: translateY(-50%);
}

.heatmap-day.is-inactive {
	background-color: #ffffff!important;
}

.heatmap.type-plays .heatmap-day.density-0 { background-color: rgba(17, 105, 135, 0.03); }
.heatmap.type-plays .heatmap-day.density-1 { background-color: rgba(17, 105, 135, 0.2); }
.heatmap.type-plays .heatmap-day.density-2 { background-color: rgba(17, 105, 135, 0.4); }
.heatmap.type-plays .heatmap-day.density-3 { background-color: rgba(17, 105, 135, 0.6); }
.heatmap.type-plays .heatmap-day.density-4 { background-color: rgba(17, 105, 135, 0.8); }
.heatmap.type-plays .heatmap-day.density-5 { background-color: rgba(17, 105, 135, 1); }

</style>
